import type { Components, Theme } from "@mui/material/styles";

export const MuiMenuItem: NonNullable<Components<Theme>["MuiMenuItem"]> = {
  defaultProps: { disableRipple: true },
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.bodyMdRegular,
    }),
  },
};
